<ion-header>
  <!-- <smart-app-banner (closeBanner)= "hideSAB()" *ngIf="ua === 'android'" [hidden] = "sab || sabSession"></smart-app-banner> -->
  <app-detailheader [include]="getInclude()" slug = "/article/{{article?.article_slug}}"
    type="article" [title]="article?.article_title" [id]="article?.article_id"
    [favorited]="article?.favorite" (notify)="headerNotify($event)">
  </app-detailheader>
</ion-header>
<ion-content class="ion-no-padding" *ngIf="article"  scrollEvents="true" (ionScroll)='onContentScroll($event)'>
  <ion-card>
    <ion-grid *ngIf = "!article.article_sponsored">
      <ion-row>
        <ion-col size="{{ article.newspaper_subname === 'ckid' ? 8 : 6 }}" [ngStyle]="{'padding': article.newspaper_subname === 'ckid' ? '3px 0px' : '5px' }">
          <div *ngIf="article.newspaper_subname">
            <div id="card-logo" [ngSwitch]="article.newspaper_subname">
              <img *ngSwitchCase="'mquo'" src="/../assets/img/monq-logo.png" class="MQ_Logo">
              <img *ngSwitchCase="'lepq'" src="/../assets/img/petitq-logo.png" class="LPQ_Logo">
              <img *ngSwitchCase="'actu'" src="/../assets/img/actulogo.png" class="MQ_Logo">
              <img *ngSwitchCase="'acne'" src="/../assets/img/acnelogo.png" class="MQ_Logo">
              <img *ngSwitchCase="'aeco'" src="/../assets/img/eco_logo_article.svg" class="ECHO_Logo">
              <img *ngSwitchCase="'mlwk'" src="/../assets/img/my-little-weekly_logo_article.svg" class="LPQ_Logo">
              <img *ngSwitchCase="'mlne'" src="/../assets/img/my-little-weekly-news_logo_article.svg" class="LPQ_Logo">
              <img *ngSwitchCase="'mljp'" src="/../assets/img/my-little-weekly_logo_article.svg" class="LPQ_Logo">
              <img *ngSwitchCase="'mlde'" src="/../assets/img/my-little-weekly_logo_article.svg" class="LPQ_Logo">
              <img *ngSwitchCase="'week'" src="/../assets/img/my-weekly_logo_article.svg" class="MW_Logo">
              <img *ngSwitchCase="'mwne'" src="/../assets/img/my-weekly-news_logo_article.svg" class="MW_Logo">
              <img *ngSwitchCase="'mwjp'" src="/../assets/img/my-weekly_logo_article.svg" class="MW_Logo">
              <img *ngSwitchCase="'mwde'" src="/../assets/img/my-weekly_logo_article.svg" class="MW_Logo">
              <img *ngSwitchCase="'woch'" src="/../assets/img/meine-woche_logo_article.svg" class="WOCH_Logo">
              <img *ngSwitchCase="'sema'" src="/../assets/img/mi-seminal_logo_article.svg" class="WOCH_Logo">
              <img *ngSwitchCase="'mquovideo'" src="/../assets/logos/mon-quotidien-video_logo_article.svg" class="WOCH_Logo">
              <img *ngSwitchCase="'actuvideo'" src="/../assets/logos/actu-video_logo_pour fond blanc.svg" class="WOCH_Logo">
              <img *ngSwitchCase="'clfy'" src="/../assets/logos/clarify_logo_article.svg" class="WOCH_Logo">
              <img *ngSwitchCase="'play'" src="/../assets/logos/pbp-logo_lesson.svg" class="WOCH_Logo">
              <img *ngSwitchCase="'frigobloc'" src="/../assets/logos/frigobloc.png" class="WOCH_Logo frigobloc">
              <img *ngSwitchCase="'ckid'" src="/../assets/logos/ckid_logo.png" class="ckid-logo">
            </div>
          </div>
        </ion-col>
        <ion-col size="{{ article.newspaper_subname === 'ckid' ? 4 : 6 }}" style="text-align: right;">
          <div id="card-pubdate" [ngClass] = "{'audio-video': article.article_type === 'audio' || article.article_type === 'video'}" *ngIf="article.publish_on && locale === 'de' && article.article_category !== 'WILLKOMMEN' && category !== 'podcast-lepq' && category !== 'lecons-de-dessin-play'">{{ article.publish_on_Obj | date:'mediumDate':'':locale }}</div>
          <div id="card-pubdate" [ngClass] = "{'audio-video': article.article_type === 'audio' || article.article_type === 'video'}" *ngIf="article.publish_on && locale !== 'de' && article.article_category !== 'BIENVENIDA' && article.article_category !== 'WELCOME' && article.article_category !== 'WILLKOMMEN' && category !== 'podcast-lepq' && category !== 'lecons-de-dessin-play'">{{ article.publish_on_Obj | date:'shortDate':'':locale }}</div>
          <div *ngIf="article.article_type === 'audio'" class="audio-icon"></div>
          <div *ngIf="article.article_type === 'video'" class="video-icon"></div>
          <div *ngIf="article.article_type === 'video' && article.newspaper_subname === 'actuvideo'" class="video-icon-actu"></div>
          <div *ngIf="article.article_type === 'video' && article.newspaper_subname === 'play'" class="video-icon-play"></div>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-grid *ngIf="article.article_sponsored" class="partner-book">
      <ion-row>
        <ion-col class="sponsor-col1">
          <span class="{{article.newspaper_subname}}">{{'TIMELINE.ARTICLE.SPONSORED.HEADER' | translate}}</span>
        </ion-col>
      </ion-row>
      <ion-row class="col2">
        <ion-col class="sponsor-col2">
            <span class="brand-name" *ngIf = "article.sponsorising">{{article.sponsorising.sponsor_name}}</span>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="rule-logo-container" *ngIf = "!article.article_sponsored">
      <div class="rule-logo"></div>
    </div>
    <ion-card-content [ngClass] = "{'sponsored': article.article_sponsored === true}">
      <div *ngIf="!article.article_sponsored" [ngClass]="{'article-detail-category-title-container': true, 'sponsored': article.article_sponsored === true}" [class]="article.newspaper_subname">
        <span [ngClass]= "{'article-category': true, 'sponsored': article.article_sponsored === true}" [class] = "article.newspaper_subname"
          *ngIf="article.article_category && !article.article_sponsored">
          {{article.article_category}}
        </span>
        <div class="clear"></div>
        <h1 [innerHTML] = "article.article_title | safeHtml"></h1>
      </div>
      <!-- for sponsored article -->
      <div *ngIf = "article.article_sponsored && article.sponsorising" [ngClass]= "{'article-detail-category-title-container': true, 'sponsored': article.article_sponsored === true}"
        [class] = "article.newspaper_subname" [style.backgroundColor] = "this.hexToRgba(article.sponsorising.header_color, 0.2)">
          <span [ngClass]= "{'article-category': true, 'sponsored': article.article_sponsored === true}" [class] = "article.newspaper_subname"
            *ngIf="article.article_category && !article.article_sponsored">
            {{article.article_category}}
          </span>
          <div class="clear"></div>
          <h1 [innerHTML] = "article.article_title | safeHtml"></h1>
        </div>
      <!-- for sponsored article -->
      <span class="interviewee" *ngIf="article.article_category === 'UNE CARRIÈRE À LA LOUPE' && article.article_subtitle && !article.article_sponsored" [innerHTML]="article.article_subtitle + '<br>' + article.article_subhead"></span>
      <span class="author" *ngIf="article.article_author && !article.article_sponsored">{{'TIMELINE.ARTICLE.DETAILS.WRITTEN_BY' | translate}} {{article.article_author}}</span>
      <div *ngIf = "article.article_category === 'ORIENTATION' && article.article_subtitle" class="orientation" [innerHTML] = "article.article_subtitle | safeHtml"></div>
      <div class="article-list-image" *ngIf="!article.carrousel">
        <img *ngIf="article.article_type !== 'video'" src="{{article.image_url}}">
        <span class="copyright" *ngIf="article.image_copyright && article.article_type !== 'video'">&copy; {{article.image_copyright | copyright}}</span>
        <div *ngIf="article.article_type === 'video'" [innerHTML]="article.video.html | safeHtml"></div>
        <div (click)="hiddenVideoOverlay()" *ngIf="article.article_type === 'video' && hideVideoOverlay" class="video-overlay"
          [ngClass] = "{'actuvideo': article.newspaper_subname === 'actuvideo', 'mquovideo': article.newspaper_subname === 'mquovideo', 'play': article.newspaper_subname === 'play'}">
        </div>
        <div *ngIf="article.newspaper_name === 'A19' && article.image_description" class="article-image-description">
          <p class="m-0">PHOTO DU JOUR</p>
          <p [innerHTML]="article.image_description" class="mb-0"></p>
          <p *ngIf="article.image_copyright" [innerHTML]="'&copy;' + article.image_copyright" class="mb-0"></p>
        </div>
      </div>
      <app-carousel *ngIf="article.carrousel" [carrousel]="article.carrousel"></app-carousel>
      <div *ngIf="article.article_type === 'audio'">
        <app-audioplayer [audiofile]="article.audio.mp3" [newspaper]="this.article.newspaper_subname" [slug]="this.article.article_slug" [category]="this.article.article_category"></app-audioplayer>
      </div>
      <div [ngClass]="{'article-detail-block': true, 'hidden': !article.article_editor_of_the_day}" (click)="isClassVisible = !isClassVisible;">
        <span class="redactor">{{article.article_editor_of_the_day}}</span>
        <div>{{'TIMELINE.ARTICLE.DETAILS.EDITOR_OF_THE_DAY' | translate}}</div>
        <div [ngClass]="{'blue-arrow-container': true, 'open': isClassVisible}"></div>
      </div>
      <div [ngClass]= "{'article-detail-block-extend': true, 'open': isClassVisible}" [innerHTML]="article.article_editor_sentence"></div>
      <!-- Context component -->
        <div [ngClass]= "{'blue-block': true, 'hidden': !article.article_context}" (click)="isContextVisible = !isContextVisible;">
        <div><span class="blue">[</span>{{'TIMELINE.ARTICLE.DETAILS.CONTEXT' | translate}}<span class="blue">]</span></div>
        <div [ngClass]= "{'blue-arrow-container': true, 'open': isContextVisible}"></div>
      </div>
      <div [ngClass]= "{'article-detail-block-extend': true, 'contexte': true, 'open': isContextVisible}" [innerHTML]="article.article_context | safeHtml" keywords></div>
      <!-- Context component -->
      <div (click)="isClassKey = true" (click) = "trackContentFrigobloc()" class="article-content" *ngIf="article.article_content" [innerHTML]="article.article_content | safeHtml" keywords></div>
      <div *ngFor = "let child of article.children">
        <div class="spacer"></div>
        <div class="child-article-title-container" [ngClass] = "child.newspaper_subname" *ngIf="child.article_title">
            <h2 [innerHTML] = "child.article_title | safeHtml"></h2>
        </div>
        <div class="child-article-subtitle" *ngIf="child.article_subtitle"><h3 [innerHTML] = "child.article_subtitle | safeHtml"></h3></div>
        <div class="article-list-image" *ngIf="!child.carrousel">
          <img *ngIf="child.article_type !== 'video' && child.image_url" src="{{child.image_url}}" [ngClass]= "{original: child.image_width <= 200}">
          <span class="copyright" *ngIf="child.image_copyright && child.article_type !== 'video'">&copy; {{child.image_copyright | copyright}}</span>
          <div *ngIf="child.article_type === 'video'" [innerHTML]="child.video.html | safeHtml"></div>
        </div>
        <app-carousel *ngIf="child.carrousel" [carrousel] = "child.carrousel"></app-carousel>
        <div *ngIf="child.article_type === 'audio'">
          <app-audioplayer [audiofile] = "child.audio.mp3"></app-audioplayer>
        </div>
        <!-- Context component -->
        <div [ngClass]= "{'blue-block': true, 'hidden': !child.article_context}" (click)="isContextVisible = !isContextVisible;">
          <div><span class="blue">[</span>{{'TIMELINE.ARTICLE.DETAILS.CONTEXT' | translate}}<span class="blue">]</span></div>
          <div [ngClass]= "{'blue-arrow-container': true, 'open': isContextVisible}"></div>
        </div>
        <div [ngClass]= "{'article-detail-block-extend': true, 'contexte': true, 'open': isContextVisible}" [innerHTML]="article.article_context | safeHtml"></div>
          <!-- Context component -->
        <div (click)="isClassKey = true" class="article-content" *ngIf="child.article_content" [innerHTML]="child.article_content | safeHtml"></div>
      </div>
      <!-- Image dropdown -->
      <div *ngIf = "article.article_side_content_title" [ngClass]= "{'article-detail-block-image': true}" (click)="isClassLearn = !isClassLearn;">
        <span [innerHTML] = "article.article_side_content_title"></span>
        <div class="image-dropdown-container-icon image-dropdown-container-lightbulb" [ngClass] = "{'sponsored': article.article_sponsored}"></div>
        <div [ngClass]= "{'blue-arrow-container': true, 'open': isClassLearn}"></div>
      </div>
      <div [ngClass]= "{'article-detail-block-extend': true, 'open': isClassLearn}" [innerHTML]="article.article_side_content"></div>
      <!-- Image dropdown -->
      <!-- Image dropdown -->
      <div *ngFor = "let child of article.children; let index = index">
        <div *ngIf = "child.article_side_content_title"  [ngClass]= "{'article-detail-block-image': true}" (click)="isClassLearnChild[index] = !isClassLearnChild[index]">
          <span [innerHTML] = "child.article_side_content_title"></span>
          <div class="image-dropdown-container-icon image-dropdown-container-lightbulb"></div>
          <div [ngClass]= "{'blue-arrow-container': true, 'open': isClassLearnChild[index]}"></div>
        </div>
        <div [ngClass]= "{'article-detail-block-extend': true, 'open': isClassLearnChild[index]}" [innerHTML]="child.article_side_content"></div>
      </div>
      <!-- Image dropdown -->
      <!-- Image dropdown -->
      <div *ngIf = "article.article_keywords" id="mots" [ngClass]= "{'article-detail-block-image': true}" (click)="isClassKey = !isClassKey;">
        <span>{{'TIMELINE.ARTICLE.DETAILS.KEYWORDS' | translate}}</span>
        <div class="image-dropdown-container-icon image-dropdown-container-keywords" [ngClass] = "{'sponsored': article.article_sponsored}"></div>
        <div [ngClass]= "{'blue-arrow-container': true, 'open': isClassKey}">
        </div>
      </div>
      <div [ngClass]= "{'article-detail-block-extend': true, 'open': isClassKey}">
        <div *ngFor="let mot of article.article_keywords">
          <div id={{mot.mot}} class="mot-title" [innerHTML]="mot.mot | safeHtml"></div>
          <div class="mot-content" [innerHTML]="mot.definition | safeHtml"></div>
        </div>
      </div>
            <!-- Image dropdown -->
                 <!-- Image dropdown -->
        <div *ngIf = "article.article_questions" [ngClass]= "{'article-detail-block-image': true}" (click)="isClassQuestion = !isClassQuestion;">
        <span *ngIf="article.newspaper_subname !== 'lepq' && article.article_questions.length === 1">{{'TIMELINE.ARTICLE.DETAILS.QUESTION' | translate}}</span>
        <span *ngIf="article.newspaper_subname !== 'lepq' && article.article_questions.length > 1">{{'TIMELINE.ARTICLE.DETAILS.QUESTION_PLURAL' | translate}}</span>
        <span class="question-lepq" *ngIf="article.newspaper_subname === 'lepq'">{{'TIMELINE.ARTICLE.DETAILS.QUESTION_LEPQ' | translate}}&reg;</span>
        <div class="image-dropdown-container-icon image-dropdown-container-question" [ngClass] = "{'sponsored': article.article_sponsored}">
        </div>
        <div [ngClass]= "{'blue-arrow-container': true, 'open': isClassQuestion}">

        </div>
      </div>
      <div [ngClass]= "{'article-detail-block-extend': true, 'question': true, 'open': isClassQuestion}" *ngFor="let question of article.article_questions; let index = index">
      <div class="question-wrapper">
        <div class="question" [innerHTML] = "question.question | safeHtml"></div>
        <div class="answer" [hidden] = "!pressAnswer[index]" [innerHTML] = "question.answer | safeHtml"></div>
        <div class="response-button" [ngClass] = "{'sponsored': article.article_sponsored}" [hidden] = "pressAnswer[index]" (click) = "pressAnswer[index] = !pressAnswer[index]">
          {{'TIMELINE.ARTICLE.DETAILS.SHOW_ANSWER' | translate}}
        </div>
      </div>
      </div>
            <!-- Image dropdown -->
                 <!-- Image dropdown -->
        <div *ngIf = "article.map_url" [ngClass]= "{'article-detail-block-image': true}" (click)="isClassEarth = !isClassEarth;">
        <span>{{'TIMELINE.ARTICLE.DETAILS.MAP' | translate}}</span>
        <div class="image-dropdown-container-icon image-dropdown-container-map">

        </div>
        <div [ngClass]= "{'blue-arrow-container': true, 'open': isClassEarth}">
        </div>
      </div>
      <div [ngClass]= "{'article-detail-block-extend': true, 'open': isClassEarth}">
        <img src="{{article.map_url}}">
        <div *ngFor = "let child of article.children">
          <div *ngIf="child.map_url">
            <img src="{{child.map_url}}">
          </div>
        </div>
      </div>
            <!-- Image dropdown -->
    </ion-card-content>
  </ion-card>
</ion-content>
<ion-footer>
    <app-bottom-menu [isActive] = "isActivePage" (app-bottomNotify) = "onBottomMenuNotify($event)"></app-bottom-menu>
</ion-footer>
<app-pop-up [show] = "tempPopUp" [data] = "popup" (popUpNotify)="onNotifyPopUp($event)" #temppopup></app-pop-up>
